import createIcon from '../../createIcon';

/**
 * @component @name ModeEditOutline
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMi45OTg1NCAxNy4yNTE1VjIxLjAwMTVINi43NDg1NEwxNy44MDg1IDkuOTQxNTJMMTQuMDU4NSA2LjE5MTUyTDIuOTk4NTQgMTcuMjUxNVoiIGZpbGw9ImJsYWNrIi8+CjxwYXRoIGQ9Ik0yMC43MDg1IDUuNjMxNTJMMTguMzY4NSAzLjI5MTUyQzE3Ljk3ODUgMi45MDE1MiAxNy4zNDg1IDIuOTAxNTIgMTYuOTU4NSAzLjI5MTUyTDE1LjEyODUgNS4xMjE1MkwxOC44Nzg1IDguODcxNTJMMjAuNzA4NSA3LjA0MTUyQzIxLjA5ODUgNi42NTE1MiAyMS4wOTg1IDYuMDIxNTIgMjAuNzA4NSA1LjYzMTUyWiIgZmlsbD0iYmxhY2siLz4KPC9zdmc+Cg==)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const ModeEditOutline = createIcon('ModeEditOutline', [
  [
    'path',
    {
      d: 'M2.99854 17.2515V21.0015H6.74854L17.8085 9.94152L14.0585 6.19152L2.99854 17.2515Z',
      key: 'kmipce',
    },
  ],
  [
    'path',
    {
      d: 'M20.7085 5.63152L18.3685 3.29152C17.9785 2.90152 17.3485 2.90152 16.9585 3.29152L15.1285 5.12152L18.8785 8.87152L20.7085 7.04152C21.0985 6.65152 21.0985 6.02152 20.7085 5.63152Z',
      key: '6ddcmp',
    },
  ],
]);

export default ModeEditOutline;
